import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { Button } from 'react-bootstrap';

import LoadingComponent from '../../../core/LoadingComponent/LoadingComponent';
import LinkComponent from '../../../core/LinkComponent/LinkComponent';
import DataComponent from './Data/DataComponent';
import NamespaceGridComponent from './NamespaceGridComponent';
import { DATA_NAMES } from './DataTypesConstants';
import { SIGN_IN_PATH } from '../../../../constants/routes';

import './dataTypes.scss';

const links = {
    xmlSchema: <LinkComponent title="XML Schema" url="https://www.w3.org/XML/Schema" isExternalLink className='blue-text' />,
    json: <LinkComponent title="JSON" url="http://json.org/" isExternalLink className='blue-text' />,
};

class DataTypesComponent extends React.Component {
    DATA_NAMES_ARRAY = [DATA_NAMES.elements, DATA_NAMES.types]

    constructor(props) {
        super(props);

        this.initialState = {};
        this.initialDataState = {};

        this.DATA_NAMES_ARRAY.forEach((dataName) => {
            this.initialDataState[dataName] = null;
        });

        props.namespaces.forEach(({ name }) => {
            this.initialState[name] = this.initialDataState;
        });

        this.state = this.initialState;
    }

    componentWillMount() {
        const { isLoading, getDataTypes } = this.props;

        if (!isLoading) {
            getDataTypes();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { namespaces: newNamespaces } = nextProps;

        if (this.props.namespaces.length === 0 && newNamespaces.length > 0) {
            newNamespaces.forEach(({ name }) => {
                this.initialState[name] = this.initialDataState;
            });

            this.setState(this.initialState);
        }
    }

    changeActiveKey = (namespaceName, dataName, activeKey) => {
        this.setState({
            ...this.initialState,
            [namespaceName]: {
                ...this.initialDataState,
                [dataName]: activeKey,
            },
        });
    }

    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Data Types Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const { isLoading, namespaces, user } = this.props;

        if (isLoading) {
            return <LoadingComponent fullScreen />;
        }

        return <div className="data-types">
            <h2>Data Types</h2>
            <p>All endpoints act on a common set of data. The data can be represented with difference media
                (i.e. "MIME") types, depending on the endpoint that consumes and/or produces the data. The data can
                described by {links.xmlSchema}, which definitively describes the XML representation of the data,
                but is also useful for describing the other formats of the data, such as {links.json}.
            </p>
            <p>This document will describe the data using terms based on {links.xmlSchema}.
                Data can be grouped by namespace, with a schema document describing the elements and types of the
                namespace. Generally speaking, types define the structure of the data and elements are instances of a
                type. For example, elements are usually produced by (or consumed by) a REST endpoint,
                and the structure of each element is described by its type.
            </p>
            {!user.uid && <Button className="redirectToSignInButton">
                <LinkComponent className="redirectToSignIn" url={SIGN_IN_PATH} title="Log In To Download" />
            </Button>}
            {user.uid && namespaces.map((namespace, namespaceIndex) => <div className="data-type" key={namespaceIndex}>
                <h4>Namespace <span>"{namespace.name}"</span></h4>
                <NamespaceGridComponent namespace={namespace} name={namespace.name} />
                <DataComponent
                    namespace={namespace}
                    namespaceName={namespace.name}
                    dataNames={this.DATA_NAMES_ARRAY}
                    activeKeys={this.state[namespace.name]}
                    setActiveKey={this.changeActiveKey}
                />
            </div>)}
        </div>;
    }
}

DataTypesComponent.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    namespaces: PropTypes.array.isRequired,
    getDataTypes: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
};

export default DataTypesComponent;



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/DataTypes/DataTypesComponent.js